/**
 * Helpers for a property's image list, which mixes plain URL strings with
 * {file, is_floorplan?, original_name?} objects depending on the endpoint.
 */

export const imageKey = (img) => (typeof img === "object" && img?.file ? img.file : img);

export const urlsOf = (list) => (list || []).map(imageKey).filter(Boolean);

/** Stable identity of an order, for "already sent this" comparisons. */
export const orderSig = (list) => urlsOf(list).join("|");

/** True when `pending` holds the same photos as `saved` in a different order. */
export const isReordered = (pending, saved) => {
  if (!pending || !saved || pending.length !== saved.length) return false;
  return pending.some((img, idx) => imageKey(img) !== imageKey(saved[idx]));
};

/**
 * Apply a saved order (URLs) to the CURRENT image list without losing
 * concurrent changes: photos in `urls` keep that order, a URL that has since
 * been deleted is dropped, and a photo added since is kept at the end.
 */
export const applyImageOrder = (images, urls) => {
  const current = images || [];
  const byUrl = new Map(current.map((img) => [imageKey(img), img]));
  const ordered = (urls || []).filter((u) => byUrl.has(u)).map((u) => byUrl.get(u));
  const placed = new Set(ordered.map(imageKey));
  return [...ordered, ...current.filter((img) => !placed.has(imageKey(img)))];
};
